export const GET_DETAILED = 'GET_DETAILED';
export const GET_RECOMMENDATION = 'GET_FOLLOWUP';
export const FETCHING_RECOMMENDATION = 'FETCHING_RECOMMENDATION';
export const SUBMIT_RECOMMENDATION = 'SUBMIT_RECOMMENDATION';
export const LOAD_RECOMMENDATION = 'LOAD_RECOMMENDATION';
export const RESET_RECOMMENDATION = 'RESET_RECOMMENDATION';
export const SET_ERROR = 'SET_ERROR';
export const RESET_ERROR = 'RESET_ERROR';

const initialState = {
  followUp: '',
  detailed: '',
  fetching: false,
  fetched: false,
  parsedResponse: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET_RECOMMENDATION:
      return {
        ...state,
        detailed: null,
        followUp: null,
        fetching: false,
        fetched: false,
        parsedResponse: null,
        error: null,
      };
    case LOAD_RECOMMENDATION:
      return {
        ...state,
        parsedResponse: action.payload,
      };
    case SUBMIT_RECOMMENDATION:
      if (action.recommendation === 'Follow-Up') {
        return {
          ...state,
          followUp: action.payload,
        };
      }
      return {
        ...state,
        detailed: action.payload,
      };

    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case RESET_ERROR:
      return {
        ...state,
        error: null,
      };
    case FETCHING_RECOMMENDATION:
      return {
        ...state,
        fetching: true,
        fetched: false,
      };
    case GET_RECOMMENDATION:
      if (action.recommendation === 'Follow-Up') {
        if (typeof action.payload === 'undefined') {
          return {
            ...state,
            followUp: '',
            fetched: true,
            fetching: false,
          };
        }
        return {
          ...state,
          followUp: action.payload,
          fetched: true,
          fetching: false,
        };
      }
      if (typeof action.payload === 'undefined') {
        return {
          ...state,
          detailed: '',
          fetched: true,
          fetching: false,
        };
      }
      return {
        ...state,
        detailed: action.payload,
        fetched: true,
        fetching: false,
      };


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/recommendations.js